import pathUtils from './pathUtils';
import _get from 'lodash/get';
import _includes from 'lodash/includes';

const authUtils = {
  getFunctionTypes: (response) => {
    const functionTypes = [];
    for (const customer of _get(response, 'customers')) {
      if (_get(customer, 'functionType')) {
        functionTypes.push(_get(customer, 'functionType'));
      }
    }
    return functionTypes;
  },
  ownedCurrentFunctionType: (ownedFunctionTypes) => _includes(ownedFunctionTypes, pathUtils.isEyewear() ? 'EYEWEAR' : 'MAKEUP'),
};

export default authUtils;
